import { relations } from 'drizzle-orm';
import { pgTable, integer, timestamp, varchar, serial } from 'drizzle-orm/pg-core';
import { account } from './account';

export const realtimeInstance = pgTable('realtime_instance', {
  id: serial().primaryKey(),
  created_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
  slots: integer().notNull().default(0),
  host: varchar({ length: 255 }),
});

export const realtimeInstancesRelations = relations(realtimeInstance, ({ many }) => ({
  accounts: many(account),
}));
